<div class="result-sub-view-container" *ngIf="model">
  <div class="rectangle"></div>
  <div class="result-sub-view-content">
    <div class="result-sub-view-title">
      <u-icon *ngIf="model.icon" class="result-sub-view-icon" [model]="iconProfile"></u-icon>
      <result-title
        *ngIf="model.title"
        class="result-sub-view-title-text"
        [model]="model.title"
        [highlights]="highlights"
        (invoke)="sendCommand($event)"
        click-invoker
      >
      </result-title>
      <result-subtitle *ngIf="model.subtitle" [model]="model.subtitle" [highlights]="highlights" (invoke)="sendCommand($event)">
      </result-subtitle>
    </div>
    <ng-container *ngIf="model.snippet">
      <result-snippet
        class="result-snippet"
        [class.show]="showFullSnippet"
        [model]="model.snippet"
        [highlights]="highlights"
        #snippet
      ></result-snippet>
    </ng-container>
    <div class="result-sub-view-bullets" *ngIf="model.bullets?.length > 0">
      <result-bullet
        data-cy="result-bullet-container"
        #resultBullet
        tabindex="-1"
        *ngFor="let bullet of model.bullets"
        [model]="bullet"
        click-invoker
        (invoke)="sendCommand($event)"
      >
      </result-bullet>
    </div>
    <div class="result-sub-view-attachment" *ngIf="model.tagGroups?.length > 0">
      <div class="tag-group" *ngFor="let group of model.tagGroups; index as i">
        <div class="result-attachment" *ngFor="let tag of group.tags">
          <result-attachment *ngIf="isAttachment(tag)" [model]="tag" (invoke)="sendCommand($event)" click-invoker> </result-attachment>
        </div>
      </div>
    </div>
  </div>
</div>
